import Immutable from 'immutable';

import User from 'sharedreact/data/User';

const Content: {
  isNewUser: boolean,
  password: string,
  passwordConfirm: string,
  user: User,
  isInitialAdmin: boolean
} = {
  isNewUser: false,
  password: '',
  passwordConfirm: '',
  user: new User(),
  isInitialAdmin: false
};

class UserWithPassword extends Immutable.Record(Content) {
  static createTemp (): UserWithPassword {
    return new UserWithPassword({
      isNewUser: true,
      user: new User()
    });
  }

  get id (): string {
    return this.user.id;
  }

  get name (): string {
    return this.user.name;
  }
}

export default UserWithPassword;
